// WAI-ARIA radiogroup arrows: forward wraps to first, back wraps to last. Null = key not handled.
export function nextRadioIndex(key: string, index: number, count: number): number | null {
  const last = count - 1;
  if (key === "ArrowRight" || key === "ArrowDown") return index === last ? 0 : index + 1;
  if (key === "ArrowLeft" || key === "ArrowUp") return index === 0 ? last : index - 1;
  return null;
}
